angular.module 'zc.commonApi'

.factory 'reportStatsResponseTransformer', () ->
  (data) ->
    try
      data = angular.fromJson data
      for stats in data.report_stats
        stats.start_at = moment(stats.start_at).valueOf() if stats.start_at
        stats.end_at = moment(stats.end_at).valueOf() if stats.end_at
      data
    catch
      {}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/report_stats_response_transformer.coffee